import { useEffect, useRef } from "react"
import { useLocation, useNavigate } from "react-router-dom"

export const Redirector = () => {
  const navigate = useNavigate()
  const hasNavigated = useRef(false);

  useEffect(() => {
    if (!hasNavigated.current) {
      const params = new URLSearchParams(window.location.search)

      const clientId = params.get("client_id")?.toString()
      const redirectUri = params.get("redirect_uri")?.toString()
      const codeChallenge = params.get("code_challenge")?.toString()
      const codeChallengeMethod = params.get("code_challenge_method")?.toString()
      const state = params.get("state")?.toString()

      console.log(redirectUri, params)

      if (clientId && redirectUri && codeChallenge && codeChallengeMethod == "S256") {
        navigate("/sign-in", {
          state: {
            clientId: clientId,
            codeChallenge: codeChallenge,
            redirectUri: redirectUri,
            state: state
          }
        })
      } else {
        navigate("/error")
      }

      hasNavigated.current = true
    }
  }, [])

  return <></>
}
